
import { footer } from '../../customWhiteLabel'
export default {
  data() {
    return {
      footer,
    }
  },
  methods: {
    redirecionaProdutoEcnpj() {
      this.$router.push('/e-cnpj')
    },
  },
}

